import { render, staticRenderFns } from "./departure.vue?vue&type=template&id=b1e2b876&scoped=true"
import script from "./departure.vue?vue&type=script&lang=js"
export * from "./departure.vue?vue&type=script&lang=js"
import style0 from "./departure.vue?vue&type=style&index=0&id=b1e2b876&prod&lang=css"
import style1 from "./departure.vue?vue&type=style&index=1&id=b1e2b876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e2b876",
  null
  
)

export default component.exports